import { hexToRGB } from 'utils/misc'

const SMALL_ICON_SIZE = '1.5rem'
const LARGE_ICON_SIZE = '3rem'

export const roundedIconButtonStyles = ({ theme }) => ({
    border: `solid 1px ${hexToRGB(theme.palette.primary.main, 0.5)}`, // Same as default outlined buttons.
    borderRadius: SMALL_ICON_SIZE,
    color: theme.palette.primary.main,
    cursor: 'pointer',
    fontSize: '0.9rem',
    marginLeft: theme.spacing(2),
    padding: 0,
    height: SMALL_ICON_SIZE,
    width: SMALL_ICON_SIZE,
    '&:hover': {
        backgroundColor: theme.palette.primary.main,
        color: '#fff'
    }
})

export const imageSettingStyles = ({ theme }) => ({
    border: 'solid 1px #fff',
    color: '#fff',
    backgroundColor: hexToRGB(theme.palette.primary.main, 0.7),
    fontSize: LARGE_ICON_SIZE,
    margin: theme.spacing(1),
    '&:hover, &.Mui-focusVisible': { backgroundColor: theme.palette.primary.main }
})

// Re-use styling across the non-collapsible gallery and the placeholder.
// Same across the listening circle and moments!
export const titleStyle = (theme) => ({
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
    color: 'white'
})
